/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

//@ts-ignore
import Slider from "react-slick";

import { IObrienSlideContainer23ViewProps } from './obrien-slide-container23';




export class ObrienSlideContainer23View extends React.PureComponent<IObrienSlideContainer23ViewProps> {

    

    constructor(props: IObrienSlideContainer23ViewProps) {
        super(props);
        this.state = {
            //nav1: null,
            nav2: null
        };
    }

    componentDidMount() {
        this.setState({
            //@ts-ignore
            //nav1: this.slider1,
            //@ts-ignore
            nav2: this.slider2
        });
      }
    

    public render(): JSX.Element {

        const { 
            uncategories,
            UnderList,
            UnderListItem,
            classNames,
            ctcategories,
            ContentList,
            ContentListItem
            
        } = this.props;

        return (
            <div className={`slideContainer23 ${classNames}`}>



                <Module {...ContentList}>
                    <Slider
                        //@ts-ignore
                        asNavFor={this.state.nav2}
                        //@ts-ignore
                        ref={slider => (this.slider1 = slider)}
                        //adaptiveHeight={true}
                        slidesToShow={1}
                        slidesToScroll={1}
                        draggable={false}
                        speed={1000}
                        infinite={false}
                    >

                        { ctcategories.map((ctcategory: ReactNode, index: number) => {
                            return (
                                <Node {...ContentListItem} key={index}>
                                    {ctcategory}
                                </Node>
                            );
                        })}
                    
                    </Slider>
                </Module>

                <Module {...UnderList}>
                    { uncategories.map((uncategory: ReactNode, index: number) => {
                        return (
                            <Node {...UnderListItem} key={index}>
                                {uncategory}
                            </Node>
                        );
                    })}
                </Module>

            </div>
    
        );
    }
    
};

export default ObrienSlideContainer23View;
